import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import {useFormicForm} from 'TemplateEditor/Layout/Blocks'
import {VideoConfigType} from 'TemplateEditor/Layout/Blocks/Video/Video'
import {DefaultBlockTopConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockTopConfig'
import {SliderInput} from 'TemplateEditor/Layout/Blocks/ConfigInputs/SliderInput'
import {DefaultBlockMobileConfig} from 'TemplateEditor/Layout/Blocks/DefaultBlockMobileConfig'
import {TEMPLATE_EDITOR_ACTIVE_FORM_ID} from 'TemplateEditor/templateEditorFormId'

export function VideoMobileConfig() {
  const {t} = useI18n()
  const {handleSubmit, values, setFieldValue} = useFormicForm<VideoConfigType>()

  return (
    <>
      <form id={TEMPLATE_EDITOR_ACTIVE_FORM_ID} onSubmit={handleSubmit}>
        <DefaultBlockTopConfig values={values} setFieldValue={setFieldValue} />

        <SliderInput
          value={values.mobile.width}
          name={'mobile.width'}
          label={t('templateEditor.widthLabel')}
          setFieldValue={setFieldValue}
          max={1000}
          min={0}
          step={1}
        />

        <SliderInput
          value={values.mobile.height}
          name={'mobile.height'}
          label={t('templateEditor.heightLabel')}
          setFieldValue={setFieldValue}
          max={1000}
          min={0}
          step={1}
        />

        <DefaultBlockMobileConfig
          values={values}
          setFieldValue={setFieldValue}
        />
      </form>
    </>
  )
}
